// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.BankDetailsEdit_modalOverlay__rkwO7 {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000;
  padding: 20px;
}

.BankDetailsEdit_modal__-Q1wH {
  background: white;
  border-radius: 8px;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.15);
  max-width: 900px;
  width: 100%;
  max-height: 90vh;
  overflow-y: auto;
  animation: BankDetailsEdit_slideIn__2zF22 0.3s ease-out;
}

@keyframes BankDetailsEdit_slideIn__2zF22 {
  from {
    opacity: 0;
    transform: translateY(-20px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}
.BankDetailsEdit_modalHeader__w54jx {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 20px 24px;
  border-bottom: 1px solid #e0e0e0;
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  color: white;
  border-radius: 8px 8px 0 0;
}
.BankDetailsEdit_modalHeader__w54jx h2 {
  margin: 0;
  font-size: 1.5rem;
  font-weight: 600;
}

.BankDetailsEdit_closeButton__ueT5A {
  background: none;
  border: none;
  color: white;
  font-size: 24px;
  cursor: pointer;
  padding: 0;
  width: 32px;
  height: 32px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 50%;
  transition: background-color 0.2s;
}
.BankDetailsEdit_closeButton__ueT5A:hover {
  background-color: rgba(255, 255, 255, 0.2);
}

.BankDetailsEdit_form__8aLj- {
  padding: 24px;
}

.BankDetailsEdit_tableContainer__AyMrV {
  margin-bottom: 20px;
  overflow-x: auto;
}

.BankDetailsEdit_formTable__3I\\+OS {
  border-collapse: collapse;
  width: 100%;
  text-align: left;
  font-family: Arial, sans-serif;
  background: white;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
}
.BankDetailsEdit_formTable__3I\\+OS table, .BankDetailsEdit_formTable__3I\\+OS th, .BankDetailsEdit_formTable__3I\\+OS td {
  border: 1px solid #333;
}
.BankDetailsEdit_formTable__3I\\+OS th, .BankDetailsEdit_formTable__3I\\+OS td {
  padding: 8px;
  vertical-align: middle;
  border: 1px solid #333;
}
.BankDetailsEdit_formTable__3I\\+OS .BankDetailsEdit_centerHeader__pxKg2 {
  text-align: center;
  font-weight: bold;
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  color: white;
  font-size: 1.1rem;
  padding: 12px 8px;
}
.BankDetailsEdit_formTable__3I\\+OS th {
  background-color: #f5f5f5;
  font-weight: bold;
  text-align: center;
  border: 1px solid #333;
}
.BankDetailsEdit_formTable__3I\\+OS td {
  border: 1px solid #333;
}
.BankDetailsEdit_formTable__3I\\+OS td:first-child {
  text-align: center;
  font-weight: bold;
  background-color: #f9f9f9;
}
.BankDetailsEdit_formTable__3I\\+OS input {
  width: 100%;
  border: none;
  outline: none;
  padding: 6px 8px;
  font-size: 14px;
  background: transparent;
  transition: background-color 0.2s;
}
.BankDetailsEdit_formTable__3I\\+OS input:focus {
  background-color: #f0f8ff;
}
.BankDetailsEdit_formTable__3I\\+OS input::placeholder {
  color: #999;
  font-style: italic;
}
.BankDetailsEdit_formTable__3I\\+OS input.BankDetailsEdit_errorInput__1BGJ3 {
  background-color: #fff5f5;
  border: 1px solid #feb2b2;
}
.BankDetailsEdit_formTable__3I\\+OS tr:nth-child(even) {
  background-color: #fafafa;
}
.BankDetailsEdit_formTable__3I\\+OS tr:hover {
  background-color: #f0f0f0;
}

.BankDetailsEdit_errorText__4P8K3 {
  color: #dc3545;
  font-size: 12px;
  margin-top: 4px;
  font-weight: 500;
}

.BankDetailsEdit_error__\\+6ppI {
  color: #dc3545;
  background-color: #f8d7da;
  border: 1px solid #f5c6cb;
  border-radius: 4px;
  padding: 10px;
  margin: 10px 0;
  font-size: 14px;
}

.BankDetailsEdit_addRowCell__ob603 {
  text-align: center;
  padding: 15px !important;
}

.BankDetailsEdit_addRowButton__Laoyd {
  background: linear-gradient(135deg, #28a745 0%, #20c997 100%);
  color: white;
  border: none;
  padding: 8px 16px;
  border-radius: 4px;
  cursor: pointer;
  font-size: 14px;
  font-weight: 500;
  transition: all 0.2s;
}
.BankDetailsEdit_addRowButton__Laoyd:hover {
  transform: translateY(-1px);
  box-shadow: 0 4px 12px rgba(40, 167, 69, 0.4);
}

.BankDetailsEdit_removeButton__tGhCZ {
  background: #dc3545;
  color: white;
  border: none;
  border-radius: 50%;
  width: 24px;
  height: 24px;
  cursor: pointer;
  font-size: 16px;
  font-weight: bold;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 0.2s;
}
.BankDetailsEdit_removeButton__tGhCZ:hover {
  background: #c82333;
  transform: scale(1.1);
}

.BankDetailsEdit_note__ry5df {
  margin: 20px 0;
  padding: 15px;
  background-color: #fff3cd;
  border: 1px solid #ffeaa7;
  border-radius: 6px;
  color: #856404;
}
.BankDetailsEdit_note__ry5df p {
  margin: 0;
  font-size: 14px;
  line-height: 1.4;
}

.BankDetailsEdit_formActions__4TlOD {
  display: flex;
  justify-content: flex-end;
  gap: 12px;
  margin-top: 24px;
  padding-top: 20px;
  border-top: 1px solid #e0e0e0;
}

.BankDetailsEdit_cancelButton__JeYWk {
  padding: 10px 20px;
  border: 1px solid #ddd;
  background: white;
  color: #666;
  border-radius: 6px;
  cursor: pointer;
  font-size: 14px;
  font-weight: 500;
  transition: all 0.2s;
}
.BankDetailsEdit_cancelButton__JeYWk:hover:not(:disabled) {
  background-color: #f5f5f5;
  border-color: #ccc;
}
.BankDetailsEdit_cancelButton__JeYWk:disabled {
  opacity: 0.6;
  cursor: not-allowed;
}

.BankDetailsEdit_submitButton__BIG0f {
  padding: 10px 24px;
  border: none;
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  color: white;
  border-radius: 6px;
  cursor: pointer;
  font-size: 14px;
  font-weight: 600;
  transition: all 0.2s;
}
.BankDetailsEdit_submitButton__BIG0f:hover:not(:disabled) {
  transform: translateY(-1px);
  box-shadow: 0 4px 12px rgba(102, 126, 234, 0.4);
}
.BankDetailsEdit_submitButton__BIG0f:disabled {
  opacity: 0.7;
  cursor: not-allowed;
  transform: none;
}

@media (max-width: 768px) {
  .BankDetailsEdit_modal__-Q1wH {
    margin: 10px;
    max-width: calc(100vw - 20px);
  }
  .BankDetailsEdit_modalHeader__w54jx {
    padding: 16px 20px;
  }
  .BankDetailsEdit_modalHeader__w54jx h2 {
    font-size: 1.3rem;
  }
  .BankDetailsEdit_form__8aLj- {
    padding: 16px;
  }
  .BankDetailsEdit_formTable__3I\\+OS {
    font-size: 12px;
  }
  .BankDetailsEdit_formTable__3I\\+OS th, .BankDetailsEdit_formTable__3I\\+OS td {
    padding: 6px;
  }
  .BankDetailsEdit_formTable__3I\\+OS input {
    font-size: 12px;
    padding: 4px 6px;
  }
  .BankDetailsEdit_formActions__4TlOD {
    flex-direction: column;
    gap: 8px;
  }
  .BankDetailsEdit_formActions__4TlOD button {
    width: 100%;
  }
}
@media (max-width: 480px) {
  .BankDetailsEdit_formTable__3I\\+OS {
    font-size: 11px;
  }
  .BankDetailsEdit_formTable__3I\\+OS th, .BankDetailsEdit_formTable__3I\\+OS td {
    padding: 4px;
  }
  .BankDetailsEdit_formTable__3I\\+OS .BankDetailsEdit_centerHeader__pxKg2 {
    font-size: 1rem;
    padding: 8px 4px;
  }
}`, "",{"version":3,"sources":["webpack://./src/components/bank-details/BankDetailsEdit.module.scss"],"names":[],"mappings":"AAAA;EACE,eAAA;EACA,MAAA;EACA,OAAA;EACA,QAAA;EACA,SAAA;EACA,oCAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,aAAA;EACA,aAAA;AACF;;AAEA;EACE,iBAAA;EACA,kBAAA;EACA,0CAAA;EACA,gBAAA;EACA,WAAA;EACA,gBAAA;EACA,gBAAA;EACA,uDAAA;AACF;;AAEA;EACE;IACE,UAAA;IACA,4BAAA;EACF;EACA;IACE,UAAA;IACA,wBAAA;EACF;AACF;AAEA;EACE,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,kBAAA;EACA,gCAAA;EACA,6DAAA;EACA,YAAA;EACA,0BAAA;AAAF;AAEE;EACE,SAAA;EACA,iBAAA;EACA,gBAAA;AAAJ;;AAIA;EACE,gBAAA;EACA,YAAA;EACA,YAAA;EACA,eAAA;EACA,eAAA;EACA,UAAA;EACA,WAAA;EACA,YAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,kBAAA;EACA,iCAAA;AADF;AAGE;EACE,0CAAA;AADJ;;AAKA;EACE,aAAA;AAFF;;AAKA;EACE,mBAAA;EACA,gBAAA;AAFF;;AAKA;EACE,yBAAA;EACA,WAAA;EACA,gBAAA;EACA,8BAAA;EACA,iBAAA;EACA,wCAAA;AAFF;AAIE;EACE,sBAAA;AAFJ;AAKE;EACE,YAAA;EACA,sBAAA;EACA,sBAAA;AAHJ;AAME;EACE,kBAAA;EACA,iBAAA;EACA,6DAAA;EACA,YAAA;EACA,iBAAA;EACA,iBAAA;AAJJ;AAOE;EACE,yBAAA;EACA,iBAAA;EACA,kBAAA;EACA,sBAAA;AALJ;AAQE;EACE,sBAAA;AANJ;AAQI;EACE,kBAAA;EACA,iBAAA;EACA,yBAAA;AANN;AAUE;EACE,WAAA;EACA,YAAA;EACA,aAAA;EACA,gBAAA;EACA,eAAA;EACA,uBAAA;EACA,iCAAA;AARJ;AAUI;EACE,yBAAA;AARN;AAWI;EACE,WAAA;EACA,kBAAA;AATN;AAYI;EACE,yBAAA;EACA,yBAAA;AAVN;AAcE;EACE,yBAAA;AAZJ;AAeE;EACE,yBAAA;AAbJ;;AAiBA;EACE,cAAA;EACA,eAAA;EACA,eAAA;EACA,gBAAA;AAdF;;AAiBA;EACE,cAAA;EACA,yBAAA;EACA,yBAAA;EACA,kBAAA;EACA,aAAA;EACA,cAAA;EACA,eAAA;AAdF;;AAiBA;EACE,kBAAA;EACA,wBAAA;AAdF;;AAiBA;EACE,6DAAA;EACA,YAAA;EACA,YAAA;EACA,iBAAA;EACA,kBAAA;EACA,eAAA;EACA,eAAA;EACA,gBAAA;EACA,oBAAA;AAdF;AAgBE;EACE,2BAAA;EACA,6CAAA;AAdJ;;AAkBA;EACE,mBAAA;EACA,YAAA;EACA,YAAA;EACA,kBAAA;EACA,WAAA;EACA,YAAA;EACA,eAAA;EACA,eAAA;EACA,iBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,oBAAA;AAfF;AAiBE;EACE,mBAAA;EACA,qBAAA;AAfJ;;AAmBA;EACE,cAAA;EACA,aAAA;EACA,yBAAA;EACA,yBAAA;EACA,kBAAA;EACA,cAAA;AAhBF;AAkBE;EACE,SAAA;EACA,eAAA;EACA,gBAAA;AAhBJ;;AAoBA;EACE,aAAA;EACA,yBAAA;EACA,SAAA;EACA,gBAAA;EACA,iBAAA;EACA,6BAAA;AAjBF;;AAoBA;EACE,kBAAA;EACA,sBAAA;EACA,iBAAA;EACA,WAAA;EACA,kBAAA;EACA,eAAA;EACA,eAAA;EACA,gBAAA;EACA,oBAAA;AAjBF;AAmBE;EACE,yBAAA;EACA,kBAAA;AAjBJ;AAoBE;EACE,YAAA;EACA,mBAAA;AAlBJ;;AAsBA;EACE,kBAAA;EACA,YAAA;EACA,6DAAA;EACA,YAAA;EACA,kBAAA;EACA,eAAA;EACA,eAAA;EACA,gBAAA;EACA,oBAAA;AAnBF;AAqBE;EACE,2BAAA;EACA,+CAAA;AAnBJ;AAsBE;EACE,YAAA;EACA,mBAAA;EACA,eAAA;AApBJ;;AAyBA;EACE;IACE,YAAA;IACA,6BAAA;EAtBF;EAyBA;IACE,kBAAA;EAvBF;EAyBE;IACE,iBAAA;EAvBJ;EA2BA;IACE,aAAA;EAzBF;EA4BA;IACE,eAAA;EA1BF;EA4BE;IACE,YAAA;EA1BJ;EA6BE;IACE,eAAA;IACA,gBAAA;EA3BJ;EA+BA;IACE,sBAAA;IACA,QAAA;EA7BF;EA+BE;IACE,WAAA;EA7BJ;AACF;AAiCA;EACE;IACE,eAAA;EA/BF;EAiCE;IACE,YAAA;EA/BJ;EAkCE;IACE,eAAA;IACA,gBAAA;EAhCJ;AACF","sourcesContent":[".modalOverlay {\n  position: fixed;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  background-color: rgba(0, 0, 0, 0.5);\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  z-index: 1000;\n  padding: 20px;\n}\n\n.modal {\n  background: white;\n  border-radius: 8px;\n  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.15);\n  max-width: 900px;\n  width: 100%;\n  max-height: 90vh;\n  overflow-y: auto;\n  animation: slideIn 0.3s ease-out;\n}\n\n@keyframes slideIn {\n  from {\n    opacity: 0;\n    transform: translateY(-20px);\n  }\n  to {\n    opacity: 1;\n    transform: translateY(0);\n  }\n}\n\n.modalHeader {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  padding: 20px 24px;\n  border-bottom: 1px solid #e0e0e0;\n  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);\n  color: white;\n  border-radius: 8px 8px 0 0;\n\n  h2 {\n    margin: 0;\n    font-size: 1.5rem;\n    font-weight: 600;\n  }\n}\n\n.closeButton {\n  background: none;\n  border: none;\n  color: white;\n  font-size: 24px;\n  cursor: pointer;\n  padding: 0;\n  width: 32px;\n  height: 32px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  border-radius: 50%;\n  transition: background-color 0.2s;\n\n  &:hover {\n    background-color: rgba(255, 255, 255, 0.2);\n  }\n}\n\n.form {\n  padding: 24px;\n}\n\n.tableContainer {\n  margin-bottom: 20px;\n  overflow-x: auto;\n}\n\n.formTable {\n  border-collapse: collapse;\n  width: 100%;\n  text-align: left;\n  font-family: Arial, sans-serif;\n  background: white;\n  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);\n\n  table, th, td {\n    border: 1px solid #333;\n  }\n\n  th, td {\n    padding: 8px;\n    vertical-align: middle;\n    border: 1px solid #333;\n  }\n\n  .centerHeader {\n    text-align: center;\n    font-weight: bold;\n    background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);\n    color: white;\n    font-size: 1.1rem;\n    padding: 12px 8px;\n  }\n\n  th {\n    background-color: #f5f5f5;\n    font-weight: bold;\n    text-align: center;\n    border: 1px solid #333;\n  }\n\n  td {\n    border: 1px solid #333;\n    \n    &:first-child {\n      text-align: center;\n      font-weight: bold;\n      background-color: #f9f9f9;\n    }\n  }\n\n  input {\n    width: 100%;\n    border: none;\n    outline: none;\n    padding: 6px 8px;\n    font-size: 14px;\n    background: transparent;\n    transition: background-color 0.2s;\n\n    &:focus {\n      background-color: #f0f8ff;\n    }\n\n    &::placeholder {\n      color: #999;\n      font-style: italic;\n    }\n\n    &.errorInput {\n      background-color: #fff5f5;\n      border: 1px solid #feb2b2;\n    }\n  }\n\n  tr:nth-child(even) {\n    background-color: #fafafa;\n  }\n\n  tr:hover {\n    background-color: #f0f0f0;\n  }\n}\n\n.errorText {\n  color: #dc3545;\n  font-size: 12px;\n  margin-top: 4px;\n  font-weight: 500;\n}\n\n.error {\n  color: #dc3545;\n  background-color: #f8d7da;\n  border: 1px solid #f5c6cb;\n  border-radius: 4px;\n  padding: 10px;\n  margin: 10px 0;\n  font-size: 14px;\n}\n\n.addRowCell {\n  text-align: center;\n  padding: 15px !important;\n}\n\n.addRowButton {\n  background: linear-gradient(135deg, #28a745 0%, #20c997 100%);\n  color: white;\n  border: none;\n  padding: 8px 16px;\n  border-radius: 4px;\n  cursor: pointer;\n  font-size: 14px;\n  font-weight: 500;\n  transition: all 0.2s;\n\n  &:hover {\n    transform: translateY(-1px);\n    box-shadow: 0 4px 12px rgba(40, 167, 69, 0.4);\n  }\n}\n\n.removeButton {\n  background: #dc3545;\n  color: white;\n  border: none;\n  border-radius: 50%;\n  width: 24px;\n  height: 24px;\n  cursor: pointer;\n  font-size: 16px;\n  font-weight: bold;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  transition: all 0.2s;\n\n  &:hover {\n    background: #c82333;\n    transform: scale(1.1);\n  }\n}\n\n.note {\n  margin: 20px 0;\n  padding: 15px;\n  background-color: #fff3cd;\n  border: 1px solid #ffeaa7;\n  border-radius: 6px;\n  color: #856404;\n\n  p {\n    margin: 0;\n    font-size: 14px;\n    line-height: 1.4;\n  }\n}\n\n.formActions {\n  display: flex;\n  justify-content: flex-end;\n  gap: 12px;\n  margin-top: 24px;\n  padding-top: 20px;\n  border-top: 1px solid #e0e0e0;\n}\n\n.cancelButton {\n  padding: 10px 20px;\n  border: 1px solid #ddd;\n  background: white;\n  color: #666;\n  border-radius: 6px;\n  cursor: pointer;\n  font-size: 14px;\n  font-weight: 500;\n  transition: all 0.2s;\n\n  &:hover:not(:disabled) {\n    background-color: #f5f5f5;\n    border-color: #ccc;\n  }\n\n  &:disabled {\n    opacity: 0.6;\n    cursor: not-allowed;\n  }\n}\n\n.submitButton {\n  padding: 10px 24px;\n  border: none;\n  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);\n  color: white;\n  border-radius: 6px;\n  cursor: pointer;\n  font-size: 14px;\n  font-weight: 600;\n  transition: all 0.2s;\n\n  &:hover:not(:disabled) {\n    transform: translateY(-1px);\n    box-shadow: 0 4px 12px rgba(102, 126, 234, 0.4);\n  }\n\n  &:disabled {\n    opacity: 0.7;\n    cursor: not-allowed;\n    transform: none;\n  }\n}\n\n// Responsive design\n@media (max-width: 768px) {\n  .modal {\n    margin: 10px;\n    max-width: calc(100vw - 20px);\n  }\n\n  .modalHeader {\n    padding: 16px 20px;\n\n    h2 {\n      font-size: 1.3rem;\n    }\n  }\n\n  .form {\n    padding: 16px;\n  }\n\n  .formTable {\n    font-size: 12px;\n\n    th, td {\n      padding: 6px;\n    }\n\n    input {\n      font-size: 12px;\n      padding: 4px 6px;\n    }\n  }\n\n  .formActions {\n    flex-direction: column;\n    gap: 8px;\n\n    button {\n      width: 100%;\n    }\n  }\n}\n\n@media (max-width: 480px) {\n  .formTable {\n    font-size: 11px;\n\n    th, td {\n      padding: 4px;\n    }\n\n    .centerHeader {\n      font-size: 1rem;\n      padding: 8px 4px;\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"modalOverlay": `BankDetailsEdit_modalOverlay__rkwO7`,
	"modal": `BankDetailsEdit_modal__-Q1wH`,
	"slideIn": `BankDetailsEdit_slideIn__2zF22`,
	"modalHeader": `BankDetailsEdit_modalHeader__w54jx`,
	"closeButton": `BankDetailsEdit_closeButton__ueT5A`,
	"form": `BankDetailsEdit_form__8aLj-`,
	"tableContainer": `BankDetailsEdit_tableContainer__AyMrV`,
	"formTable": `BankDetailsEdit_formTable__3I+OS`,
	"centerHeader": `BankDetailsEdit_centerHeader__pxKg2`,
	"errorInput": `BankDetailsEdit_errorInput__1BGJ3`,
	"errorText": `BankDetailsEdit_errorText__4P8K3`,
	"error": `BankDetailsEdit_error__+6ppI`,
	"addRowCell": `BankDetailsEdit_addRowCell__ob603`,
	"addRowButton": `BankDetailsEdit_addRowButton__Laoyd`,
	"removeButton": `BankDetailsEdit_removeButton__tGhCZ`,
	"note": `BankDetailsEdit_note__ry5df`,
	"formActions": `BankDetailsEdit_formActions__4TlOD`,
	"cancelButton": `BankDetailsEdit_cancelButton__JeYWk`,
	"submitButton": `BankDetailsEdit_submitButton__BIG0f`
};
export default ___CSS_LOADER_EXPORT___;
